<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stockPositionLabelsSelected"
    :clearable="!unclearable"
    :items="positionLabelsItems"
    :loading="Loading"
    :search-input.sync="search"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('CurrentPosition.Fields.position_label')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import stockPositionLabels from "@/api/stock_position_labels";

export default {
  name: "SearcherPositionLabels",

  props: {
    value: Object,
    stockId: Number,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    positionLabelsItems() {
      return this.stock_position_labels.map((e) => {
        const Description = e.label_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == e.id)
          : false;
        return Object.assign({}, e, { Description, disabled });
      });
    },
  },

  data: () => ({
    stock_position_labels: [],
    Loading: false,
    search: "",
    stockPositionLabelsSelected: null,
  }),

  mounted() {
    this.getStockPositionLabelsFromAPI();
  },

  methods: {
    getStockPositionLabelsFromAPI() {
      this.Loading = true;
      stockPositionLabels
        .fetchAllForSelect({ stock_id: this.stockId })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_position_labels = response.data.stock_position_labels;
            }
            this.Loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.Loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockPositionLabelsSelected = this.value;
      },
    },
    stockPositionLabelsSelected: {
      handler() {
        this.$emit("input", this.stockPositionLabelsSelected);
      },
    },
    stockId: {
      handler() {
        this.getStockPositionLabelsFromAPI();
      },
    },
  },
};
</script>
